import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactSVG } from 'react-svg';

import { Colors } from '../../../scss/common/style';

interface Props {
  title: string;
  isSelected?: boolean;
  isDisabled?: boolean;
  link: string;
  subTitle?: string;
  icon?: any;
}

export default function NavLink({
  link,
  title,
  subTitle = 'null',
  isSelected = false,
  isDisabled = true,
  icon,
}: Props): JSX.Element {
  return (
    <div className="text-center" data-tip data-for={`sentToManager_${title}`}>
      <SecondaryNavigationLink
        className={`secondary-navigation-link${isSelected ? ' secondary-navigation-link-active' : ''}${
          isDisabled ? ' secondary-navigation-link-disabled' : ''
        }`}
        to={link}
        onClick={isDisabled ? (e) => e.preventDefault() : null}
      >
        {icon && <StyledImg src={icon} alt={icon} />}
        <span className="secondary-navigation-link-inner">{title}</span>
      </SecondaryNavigationLink>

      {subTitle ? (
        <span
          className={`secondary-navigation-link-subtitle${
            isSelected ? ' secondary-navigation-link-subtitle-active' : ''
          }${isDisabled ? ' secondary-navigation-link-subtitle-disabled' : ''}`}
        >
          {subTitle}
        </span>
      ) : null}
    </div>
  );
}

const StyledImg = styled(ReactSVG)`
  height: 50px;
  width: 50px;
  svg {
    height: 50px;
    width: 50px;
  }
`;

const SecondaryNavigationLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  background-color: #fbfbfb;
  border: 1px solid #eeeeee;
  color: ${Colors.darkBrown};
  margin-bottom: 6px;
  width: 128px;
  height: 110px;
  &.secondary-navigation-link:hover {
    background-color: #eeeeee;
    color: ${Colors.darkBrown};
    text-decoration: none;
  }
  &.secondary-navigation-link {
    &.secondary-navigation-link-active {
      background-clip: content-box;
      background-color: ${Colors.darkBrown};
      border: 1px solid ${Colors.darkBrown};
      font-weight: 400;
      color: #fff;
      svg path {
        stroke: #fff;
      }
    }

    .secondary-navigation-link-inner {
      margin: 3px 5px;
      display: inline-block;
    }
  }
`;
